import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CircleOffIcon, SmartphoneIcon, BanIcon, ShuffleIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function PainAndSolutions() {
  return <section className="w-full" data-id="element-238">
      {/* Pain Points */}
      <div className="py-16 md:py-24 px-6" style={{
      backgroundColor: 'var(--cream)'
    }} data-id="element-239">
        <div className="max-w-2xl mx-auto" data-id="element-240">
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="font-serif text-2xl md:text-3xl mb-10" style={{
          color: 'var(--navy)'
        }} data-id="element-241">
            Si esto te suena familiar…
          </motion.h2>

          <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} className="space-y-5 mb-12" role="list" data-id="element-242">
            <motion.li variants={itemVariants} className="flex items-start gap-3 text-base md:text-lg" style={{
            color: 'var(--charcoal)',
            lineHeight: '1.7'
          }} data-id="element-243">
              <span className="mt-1.5 w-2 h-2 rounded-full flex-shrink-0" style={{
              backgroundColor: 'var(--gold)'
            }} data-id="element-244" />
              Cobras y en pocos días ya estás "ajustada/o".
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start gap-3 text-base md:text-lg" style={{
            color: 'var(--charcoal)',
            lineHeight: '1.7'
          }} data-id="element-245">
              <span className="mt-1.5 w-2 h-2 rounded-full flex-shrink-0" style={{
              backgroundColor: 'var(--gold)'
            }} data-id="element-246" />
              Dices "esta quincena no gasto", pero llega un día difícil y
              compras.
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start gap-3 text-base md:text-lg" style={{
            color: 'var(--charcoal)',
            lineHeight: '1.7'
          }} data-id="element-247">
              <span className="mt-1.5 w-2 h-2 rounded-full flex-shrink-0" style={{
              backgroundColor: 'var(--gold)'
            }} data-id="element-248" />
              Te da vergüenza ver tus números, así que los evitas.
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start gap-3 text-base md:text-lg" style={{
            color: 'var(--charcoal)',
            lineHeight: '1.7'
          }} data-id="element-249">
              <span className="mt-1.5 w-2 h-2 rounded-full flex-shrink-0" style={{
              backgroundColor: 'var(--gold)'
            }} data-id="element-250" />
              Pagas mínimos, y sientes que trabajas para el banco.
            </motion.li>
            <motion.li variants={itemVariants} className="flex items-start gap-3 text-base md:text-lg" style={{
            color: 'var(--charcoal)',
            lineHeight: '1.7'
          }} data-id="element-251">
              <span className="mt-1.5 w-2 h-2 rounded-full flex-shrink-0" style={{
              backgroundColor: 'var(--gold)'
            }} data-id="element-252" />
              Has probado apps, tips, videos… y nada se queda.
            </motion.li>
          </motion.ul>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-4" style={{
          lineHeight: '1.8'
        }} data-id="element-253">
            <p className="text-base md:text-lg" style={{
            color: 'var(--charcoal)'
          }} data-id="element-254">
              No es que no quieras.
            </p>
            <p className="text-base md:text-lg" style={{
            color: 'var(--charcoal)'
          }} data-id="element-255">
              Es que tu plan actual depende de que siempre estés tranquila/o,
              enfocada/o y perfecta/o.
            </p>
            <p className="text-base md:text-lg font-medium" style={{
            color: 'var(--navy)'
          }} data-id="element-256">
              Y nadie vive así.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Why old solutions fail */}
      <div className="py-16 md:py-24 px-6" style={{
      backgroundColor: 'var(--light-navy)'
    }} data-id="element-257">
        <div className="max-w-2xl mx-auto" data-id="element-258">
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="font-serif text-2xl md:text-3xl mb-4" style={{
          color: 'var(--navy)'
        }} data-id="element-259">
            Por qué lo que intentaste antes falla
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-base mb-12" style={{
          color: 'var(--charcoal)',
          opacity: 0.7
        }} data-id="element-260">
            (y no es tu culpa)
          </motion.p>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} className="space-y-6" data-id="element-261">
            {/* Card 1 */}
            <motion.div variants={itemVariants} className="p-6 rounded-xl" style={{
            backgroundColor: 'white',
            border: '1px solid rgba(27, 42, 74, 0.08)'
          }} data-id="element-262">
              <div className="flex items-start gap-4" data-id="element-263">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(27, 42, 74, 0.06)'
              }} data-id="element-264">
                  <CircleOffIcon className="w-5 h-5" style={{
                  color: 'var(--navy)'
                }} data-id="element-265" />
                </div>
                <div data-id="element-266">
                  <h3 className="font-semibold text-base mb-1" style={{
                  color: 'var(--navy)'
                }} data-id="element-267">
                    Presupuestos "bonitos" sin realidad emocional
                  </h3>
                  <p className="text-sm" style={{
                  color: 'var(--charcoal)',
                  opacity: 0.75,
                  lineHeight: '1.7'
                }} data-id="element-268">
                    El 50/30/20 suena bien… hasta que hay deuda, estrés y vida
                    real.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Card 2 */}
            <motion.div variants={itemVariants} className="p-6 rounded-xl" style={{
            backgroundColor: 'white',
            border: '1px solid rgba(27, 42, 74, 0.08)'
          }} data-id="element-269">
              <div className="flex items-start gap-4" data-id="element-270">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(27, 42, 74, 0.06)'
              }} data-id="element-271">
                  <SmartphoneIcon className="w-5 h-5" style={{
                  color: 'var(--navy)'
                }} data-id="element-272" />
                </div>
                <div data-id="element-273">
                  <h3 className="font-semibold text-base mb-1" style={{
                  color: 'var(--navy)'
                }} data-id="element-274">
                    Apps que te convierten en contadora/o de tu propio cansancio
                  </h3>
                  <p className="text-sm" style={{
                  color: 'var(--charcoal)',
                  opacity: 0.75,
                  lineHeight: '1.7'
                }} data-id="element-275">
                    Si el sistema requiere constancia perfecta, lo vas a soltar
                    el primer mes difícil.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Card 3 */}
            <motion.div variants={itemVariants} className="p-6 rounded-xl" style={{
            backgroundColor: 'white',
            border: '1px solid rgba(27, 42, 74, 0.08)'
          }} data-id="element-276">
              <div className="flex items-start gap-4" data-id="element-277">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(27, 42, 74, 0.06)'
              }} data-id="element-278">
                  <BanIcon className="w-5 h-5" style={{
                  color: 'var(--navy)'
                }} data-id="element-279" />
                </div>
                <div data-id="element-280">
                  <h3 className="font-semibold text-base mb-1" style={{
                  color: 'var(--navy)'
                }} data-id="element-281">
                    "No compres" no es un plan
                  </h3>
                  <p className="text-sm" style={{
                  color: 'var(--charcoal)',
                  opacity: 0.75,
                  lineHeight: '1.7'
                }} data-id="element-282">
                    Es castigo. Y el castigo rebota.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Card 4 */}
            <motion.div variants={itemVariants} className="p-6 rounded-xl" style={{
            backgroundColor: 'white',
            border: '1px solid rgba(27, 42, 74, 0.08)'
          }} data-id="element-283">
              <div className="flex items-start gap-4" data-id="element-284">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: 'rgba(27, 42, 74, 0.06)'
              }} data-id="element-285">
                  <ShuffleIcon className="w-5 h-5" style={{
                  color: 'var(--navy)'
                }} data-id="element-286" />
                </div>
                <div data-id="element-287">
                  <h3 className="font-semibold text-base mb-1" style={{
                  color: 'var(--navy)'
                }} data-id="element-288">
                    Todo en la misma cuenta = todo se confunde
                  </h3>
                  <p className="text-sm" style={{
                  color: 'var(--charcoal)',
                  opacity: 0.75,
                  lineHeight: '1.7'
                }} data-id="element-289">
                    Y lo confuso… se gasta.
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}